import React from 'react';
interface CoachCardProps {
  name: string;
  role: string;
  bio: string;
  imageUrl: string;
}
export function CoachCard({
  name,
  role,
  bio,
  imageUrl
}: CoachCardProps) {
  return <div className="bg-paper rounded-2xl overflow-hidden shadow-soft border border-subtle-gray group" data-id="element-67">
      <div className="aspect-[4/5] overflow-hidden relative" data-id="element-68">
        <div className="absolute inset-0 bg-gradient-to-t from-ink/80 to-transparent z-10" data-id="element-69" />
        <img src={imageUrl} alt={name} className="w-full h-full object-cover filter grayscale group-hover:grayscale-0 transition-all duration-500 transform group-hover:scale-105" data-id="element-70" />
        <div className="absolute bottom-0 left-0 p-6 z-20 w-full" data-id="element-71">
          <p className="text-storm-red font-bold uppercase tracking-wide text-sm mb-1" data-id="element-72">
            {role}
          </p>
          <h3 className="text-3xl text-white mb-0" data-id="element-73">{name}</h3>
        </div>
      </div>
      <div className="p-6" data-id="element-74">
        <p className="text-gray-warm leading-relaxed" data-id="element-75">{bio}</p>
      </div>
    </div>;
}